module.exports = __webpack_public_path__ + "resources/img/lan-jp.fddd2a60.png";